import { Box, Button, IconButton, Tooltip } from "@chakra-ui/react";
import React, { Component } from "react";
import { FaChevronDown, FaPlus, FaTimes } from "react-icons/fa";
import { batch, connect } from "react-redux";
import {
  closeBottomPanel,
  openBottomPanel,
} from "../_actions/bottomPanelActions";
import { moveArtboard, wsAddPage } from "../_actions/webSocketAction";
import { DraggablePreviewArtBoard } from "../_components/common/statelessView";
import {
  StyledArtBoardEmptyContainer,
  StyledArtBoardRearrangeGridContainer,
} from "../_components/styled/details/styleArtBoardEditor";
import { BottomPanelViewTypes } from "../_utils/constants";
import { checkArtboardLimit } from "../_utils/common";
import { withTranslation } from "react-i18next";

const artboardCount = {
  iconSpacing: 2,
  h: 6,
  _hover: { bg: "gray.300" },
};

class ArtBoardRearrangeGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      destinationIndex: 0,
      destinationId: 0,
    };
  }

  onClickClose = () => {
    const { closeBottomPanel } = this.props;
    batch(() => {
      closeBottomPanel();
    });
  };

  onClickMinimizeView = () => {
    const { openBottomPanel } = this.props;
    batch(() => {
      openBottomPanel(BottomPanelViewTypes.PREVIEW_ARTBOARDS);
    });
  };

  render() {
    const { pages, pageIds } = this.props.pagestore;

    const { activePage, t, canvasRef } = this.props;

    const previewArtBoards = pageIds.map((pageId) => {
      return (
        <DraggablePreviewArtBoard
          key={pageId}
          id={pageId}
          page={pages[pageId]}
          onMoveItem={this.moveItem}
          onDrop={this.dropItem}
          isCurrentPage={pageId === activePage.id}
          canvasRef={canvasRef}
        />
      );
    });

    return (
      <StyledArtBoardRearrangeGridContainer>
        <div
          id="grid-title-bar"
          className="title-bar"
          onClick={(e) => {
            if (e.target.id === "grid-title-bar") this.onClickClose();
          }}
        >
          <div className="title-display">
            <Button
              rightIcon={<FaChevronDown />}
              sx={artboardCount}
              onClick={this.onClickClose}
              size="sm"
              variant="ghost"
            >
              {previewArtBoards.length} {t("artboards")}
            </Button>
          </div>
          <div className="actions">
            <div className="actions-container">
              <Box display={["none", "none", "block", "block"]}>
                <Tooltip hasArrow placement="bottom" label={t("minimize")}>
                  <IconButton
                    onClick={this.onClickMinimizeView}
                    sx={artboardCount}
                    icon={<FaChevronDown />}
                    variant="ghost"
                    size="sm"
                    aria-label="icon-chevron"
                  />
                </Tooltip>
              </Box>
              <Tooltip placement="bottom" hasArrow label={t("close_full_view")}>
                <IconButton
                  onClick={this.onClickClose}
                  sx={artboardCount}
                  icon={<FaTimes />}
                  variant="ghost"
                  size="sm"
                  aria-label="icon-times"
                />
              </Tooltip>
            </div>
          </div>
        </div>

        <div className="re-arrange-grid">
          {previewArtBoards}
          <Tooltip hasArrow placement="bottom" label={t("add_artboard")}>
            <StyledArtBoardEmptyContainer onClick={this.onClickAddArtBoard}>
              <FaPlus />
            </StyledArtBoardEmptyContainer>
          </Tooltip>
        </div>
      </StyledArtBoardRearrangeGridContainer>
    );
  }

  moveItem = (sourceId, destinationId) => {
    const { pageIds } = this.props.pagestore;

    const sourceIndex = pageIds.findIndex((item) => item === sourceId);
    const destinationIndex = pageIds.findIndex(
      (item) => item === destinationId
    );

    if (sourceId === -1 || destinationId === -1) {
      return;
    }

    const offset = destinationIndex - sourceIndex;

    this.moveElement(this.props.pagestore.pageIds, sourceIndex, offset);

    this.setState({
      destinationIndex: destinationIndex,
      destinationId,
    });
  };

  moveElement = (array, index, offset) => {
    const newIndex = index + offset;

    return this.move(array, index, newIndex);
  };

  move = (array, oldIndex, newIndex) => {
    if (newIndex >= array.length) {
      newIndex = array.length - 1;
    }
    array.splice(newIndex, 0, array.splice(oldIndex, 1)[0]);
    return array;
  };

  dropItem = (pageId) => {
    if (pageId !== this.state.destinationId) {
      this.props.moveArtboard(pageId, this.state.destinationIndex);
    }
  };

  onClickAddArtBoard = () => {
    const { pagestore, subscription } = this.props;
    const isAvailable = checkArtboardLimit(pagestore, subscription);
    if (isAvailable) this.props.wsAddPage();
  };
}

const mapStateToProps = (state) => ({
  pagestore: state.pagestore,
  activePage: state.editor.activePage,
  subscription: state.subscription,
});

const mapDispatchToProps = (dispatch) => ({
  moveArtboard: (pageId, destinationIndex) =>
    dispatch(moveArtboard(pageId, destinationIndex)),
  wsAddPage: () => dispatch(wsAddPage()),
  openBottomPanel: (panelType) => dispatch(openBottomPanel(panelType)),
  closeBottomPanel: () => dispatch(closeBottomPanel()),
});

export default withTranslation(["studio"])(
  connect(mapStateToProps, mapDispatchToProps)(ArtBoardRearrangeGrid)
);
